module.exports = __webpack_public_path__ + "static/media/lancome-la-vie-est-belle-big.141f02fb.png";